import Vue from 'vue'
import VueResource from 'vue-resource'
Vue.use(VueResource)

//In the project entry file
//import Vue from 'vue'
import VueStar from 'vue-star'
Vue.component('VueStar', VueStar)